// Le panneau « Consignes et objectifs » du dashboard coach web (la fiche
// Gym'Coach d'une séance, signée coach), reproduit d'après components/coach/
// ConsignesPanel.js et les règles .consignes-* et .modal-* d'App.css et de
// gnv3-overrides.css (thème clair). Les valeurs s'affichent comme dans les
// champs réels : « 82.5 », « 8.5 ».
//
// En grand (chapitre coach) : la fenêtre à sa largeur sur un écran de 700 px
// (90 %, soit 630 px), sur l'éditeur de séance flouté. Animé une fois : le
// coach écrit la consigne de la série 2, enregistre, la fiche passe en
// version 3 et le message confirme que l'élève est prévenu.
// En compact (haut de page) : le bloc de l'exercice seul, série 2, dans la
// mise en page étroite du panneau (sous 640 px) ; la consigne s'écrit en boucle.
import React from "react";
import Apercu from "./Apercu";
import { ModaleWeb } from "./Cadres";

const EXERCICE = "Tirage horizontal";
const CONSIGNE_EXERCICE = "Coudes près du corps, une seconde de pause en fin de tirage.";
const RESUME = "On charge le tirage, on garde de la marge sur la fin.";
const CONSIGNE_TAPEE = "Deux reps en réserve";

// La série 2 est celle que le coach complète (consigne écrite à l'écran).
const SERIES = [
	{ ordre: 0, reps: "8", poids: "82.5", rpe: "8", avant: "8 × 80" },
	{ ordre: 1, reps: "8", poids: "80", rpe: "8.5", avant: "8 × 80", tapee: true },
	{ ordre: 2, reps: "7", poids: "80", rpe: "", avant: "6 × 80" },
];

function Champ({ valeur, indication, className = "" }) {
	return (
		<span className={`gs-cp-champ ${className}`.trim()}>
			{valeur || <span className="gs-cp-indication">{indication}</span>}
		</span>
	);
}

// Le champ « consigne » de la série 2 : vide (indication), puis le texte qui
// s'écrit avec le curseur.
function ChampTape() {
	return (
		<span className="gs-cp-champ gs-cp-champ--texte gs-cp-champ--tape">
			<span className="gs-cp-indication gs-cp-indication--avant">consigne (facultatif)</span>
			<span className="gs-cp-frappe">{CONSIGNE_TAPEE}</span>
			<span className="gs-cp-curseur-boite">
				<span className="gs-cp-curseur" />
			</span>
		</span>
	);
}

function Serie({ serie, compact = false }) {
	return (
		<div className="gs-cp-serie">
			<span className="gs-cp-num">Série {serie.ordre + 1}</span>
			<Champ valeur={serie.reps} indication="reps" />
			<Champ valeur={serie.poids} indication="kg" />
			<Champ valeur={serie.rpe} indication="RPE" />
			{serie.tapee ? <ChampTape /> : <Champ indication="consigne (facultatif)" className="gs-cp-champ--texte" />}
			{!compact && <span className="gs-cp-retirer">Retirer</span>}
			{!compact && <span className="gs-cp-avant">Dernière fois : {serie.avant} kg</span>}
		</div>
	);
}

function BlocExercice({ compact = false }) {
	const series = compact ? SERIES.filter((s) => s.tapee) : SERIES;
	return (
		<div className={`gs-cp-bloc${compact ? " gs-cp-bloc--compact" : ""}`}>
			<h4>{EXERCICE}</h4>
			{!compact && (
				<>
					<span className="gs-cp-label">Consigne de l'exercice</span>
					<span className="gs-cp-zone">{CONSIGNE_EXERCICE}</span>
				</>
			)}
			{series.map((s) => (
				<Serie key={s.ordre} serie={s} compact={compact} />
			))}
		</div>
	);
}

export default function ApercuConsigne({ boucle = false, compact = false, className = "" }) {
	if (compact) {
		return (
			<Apercu
				boucle={boucle}
				className={className}
				description={`Consigne du coach sur la série 2 du ${EXERCICE.toLowerCase()} : 8 × 80 kg, RPE 8.5, « ${CONSIGNE_TAPEE} ».`}
			>
				<BlocExercice compact />
			</Apercu>
		);
	}

	return (
		<Apercu
			boucle={boucle}
			className={className}
			description={`Panneau « Consignes et objectifs » du dashboard coach pour la séance Pull : objectifs par série du ${EXERCICE.toLowerCase()}, le coach écrit « ${CONSIGNE_TAPEE} » sur la série 2 et enregistre ; l'élève est prévenu dans l'app.`}
		>
			{/* .modal-overlay (gnv3-overrides.css) : voile vert-noir à 50 %, flou de 8 px. */}
			<ModaleWeb largeur={700} marge="28px 35px" voile="rgba(20, 30, 27, 0.5)" flou={8} page="editeur">
				<div className="gs-cp">
					<span className="gs-cp-fermer">×</span>
					<div className="gs-cp-interieur">
						<div className="gs-cp-entete">
							<h2>Consignes et objectifs</h2>
							<span className="gs-cp-badge">Personnalisée</span>
							<span className="gs-cp-version">
								<span className="gs-cp-version-avant">version 2</span>
								<span className="gs-cp-version-apres">version 3</span>
							</span>
						</div>
						<p className="gs-cp-intro">
							Pull du 07/10/2026. Tout ce que vous enregistrez ici est signé coach et prime sur les propositions
							GymNote.
						</p>
						<div className="gs-cp-filet" />

						<div className="gs-cp-bloc">
							<span className="gs-cp-label">Résumé pour l'élève</span>
							<span className="gs-cp-zone">{RESUME}</span>
						</div>
						<BlocExercice />

						<p className="gs-cp-message">Fiche enregistrée (version 3). L'élève est prévenu dans l'app.</p>
						<div className="gs-cp-actions">
							<span className="gs-cp-btn gs-cp-btn--secondaire">Préremplir avec Gym'Coach</span>
							<span className="gs-cp-btn gs-cp-btn--enregistrer">Enregistrer</span>
						</div>
					</div>
				</div>
			</ModaleWeb>
		</Apercu>
	);
}
